/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { formStyles } from '@blend/consumer-components';

const styles = StyleSheet.create({
  wrapper: formStyles.controlButtonWrapper,
});

export namespace RadioWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const RadioWrapper: React.SFC<RadioWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.wrapper)} {...htmlProps}>
      {children}
    </div>
  );
};
